// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiCompleteMultipartUploadRequestPart } from '../models/ApiCompleteMultipartUploadRequestPart';
import { HttpFile } from '../http/http';

export class ApiCompleteMultipartUploadRequest {
    'upload_id': string;
    'key': string;
    'parts': Array<ApiCompleteMultipartUploadRequestPart>;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "upload_id",
            "baseName": "upload_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "parts",
            "baseName": "parts",
            "type": "Array<ApiCompleteMultipartUploadRequestPart>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiCompleteMultipartUploadRequest.attributeTypeMap;
    }

    public constructor() {
    }
}
